import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CountryService } from 'src/app/country.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ex-calc',
  templateUrl: './ex-calc.component.html',
  styleUrls: ['./ex-calc.component.css']
})
export class ExCalcComponent implements OnInit {

  exchange = {
    amount: '1000',
    receiveAmt: '0',
    feeType: 0,
    label: "First",
    fromId: "",
    toId: "",
    fromCountryId: "",
    toCountryId: "",
    singxFee: '0',
    exchangeRate: 0
  };
  showInverseRates = false;
  sendCurrencies = [];
  countryList = [];
  sendCurrency: any;
  receiveCurrency: any;
  sendFilterInpt = "";
  receiveFilterInpt = "";
  exCalcSendPopoverVisible = false;
  exCalcReceivePopoverVisible = false;
  sendAmountChanged: Subject<string> = new Subject<string>();
  receiveAmountChanged: Subject<string> = new Subject<string>();
  localStorage;
  country = 'sg';

  constructor(private http: HttpClient, private route: ActivatedRoute, @Inject(DOCUMENT) document,
    private cs: CountryService) {
    this.localStorage = document.defaultView.localStorage;
  }

  ngOnInit(): void {
    this.country = this.cs.getCountry();
    var configFile = "./assets/config-au.json";
    if (this.country != "au") {
      this.http.get(environment.apiBase + "/central/landing/fx/" + this.country.toUpperCase() + "/corridors").subscribe(r => {
        this.sendCurrencies = [];
        const toCountriesMap = new Map();
        Object.keys(r).forEach(sc => {
          switch (sc) {
            case "SGD":
              this.sendCurrencies.push(
                {
                  "currencyCode": "SGD",
                  "currencyName": "Singapore Dollars",
                  "flag": "sg"
                }
              );
              break;
            case "HKD":
              this.sendCurrencies.push(
                {
                  "currencyCode": "HKD",
                  "currencyName": "Hong Kong Dollars",
                  "flag": "hk"
                }
              );
              break;
            case "USD":
              this.sendCurrencies.push(
                {
                  "currencyCode": "USD",
                  "currencyName": "United States Dollars",
                  "flag": "us"
                }
              );
              break;
          }
          r[sc].forEach(rc => {
            toCountriesMap.set(rc.key, {
              "currencyCode": rc.key,
              "currencyName": rc.value,
              "flag": rc.key.toLowerCase().substr(0, 2)
            });
          });
        });
        for (const value of toCountriesMap.values()) {
          this.countryList.push(value);
        }
        this.countryList = this.countryList.sort((a, b) => a["currencyCode"].localeCompare(b["currencyCode"]));
        this.sendCurrency = this.sendCurrencies[0];
        this.receiveCurrency = this.countryList[0];
        this.exchange.fromId = this.sendCurrency['currencyCode'];
        this.exchange.toId = this.receiveCurrency['currencyCode'];
        var exLs = this.localStorage.getItem('ex-calc');
        var rcrr = "INR";
        if (exLs) {
          exLs = JSON.parse(exLs);
          if (exLs['toId']) {
            this.updateReceiverCurrency(exLs['toId']);
            rcrr = exLs['toId'];
          }
          if (exLs['receiveAmt'] > 0)
            this.exchange.receiveAmt = exLs['receiveAmt'];
          if (exLs['amount'] > 0)
            this.exchange.amount = exLs['amount'];
          if (exLs['label'])
            this.exchange.label = exLs['label'];
          if (exLs['fromId']) {
            this.sendCurrencies.forEach(c => {
              if (c.currencyCode.toLowerCase() == exLs['fromId'].toLowerCase()) {
                this.sendCurrency = c;
                this.exchange.fromCountryId = this.sendCurrency['countryId'];
                this.exchange.fromId = this.sendCurrency['currencyCode'];
              }
            })
          }
        }
        this.route.queryParams.subscribe(q => {
          this.updateReceiverCurrency(q.sendTo ? q.sendTo : rcrr);
        });

        this.getExchangeRate();
        console.log(r);
      });
    } else {
      this.http.get(configFile).subscribe(resp => {
        this.sendCurrencies = resp['sendCurrencies'];
        this.countryList = resp['countryList'];
        this.sendCurrency = this.sendCurrencies[0];
        this.receiveCurrency = this.countryList[0];
        this.exchange.fromCountryId = this.sendCurrency['countryId'];
        this.exchange.toCountryId = this.receiveCurrency['countryId'];
        this.exchange.fromId = this.sendCurrency['currencyCode'];
        this.exchange.toId = this.receiveCurrency['currencyCode'];
        var exLs = this.localStorage.getItem('ex-calc');
        var rcrr = "INR";
        if (exLs) {
          exLs = JSON.parse(exLs);
          if (exLs['toId']) {
            this.updateReceiverCurrency(exLs['toId']);
            rcrr = exLs['toId'];
          }
          if (exLs['receiveAmt'] > 0)
            this.exchange.receiveAmt = exLs['receiveAmt'];
          if (exLs['amount'] > 0)
            this.exchange.amount = exLs['amount'];
          if (exLs['label'])
            this.exchange.label = exLs['label'];
          if (exLs['fromId']) {
            this.sendCurrencies.forEach(c => {
              if (c.currencyCode.toLowerCase() == exLs['fromId'].toLowerCase()) {
                this.sendCurrency = c;
                this.exchange.fromCountryId = this.sendCurrency['countryId'];
                this.exchange.fromId = this.sendCurrency['currencyCode'];
              }
            })
          }
        }
        this.route.queryParams.subscribe(q => {
          this.updateReceiverCurrency(q.sendTo ? q.sendTo : rcrr);
        });

        this.getExchangeRate();
      });
    }

    this.sendAmountChanged.pipe(debounceTime(1000)).subscribe(sa => {
      this.exchange = {
        amount: sa,
        receiveAmt: '0',
        feeType: 0,
        label: "First",
        fromId: this.exchange.fromId,
        toId: this.exchange.toId,
        fromCountryId: this.exchange.fromCountryId,
        toCountryId: this.exchange.toCountryId,
        singxFee: '0',
        exchangeRate: 0
      };
      this.getExchangeRate();
    });

    this.receiveAmountChanged.pipe(debounceTime(1000)).subscribe(sa => {
      this.exchange = {
        amount: '0',
        receiveAmt: sa,
        feeType: 0,
        label: "Second",
        fromId: this.exchange.fromId,
        toId: this.exchange.toId,
        fromCountryId: this.exchange.fromCountryId,
        toCountryId: this.exchange.toCountryId,
        singxFee: '0',
        exchangeRate: 0
      };
      this.getExchangeRate();
    });

  }

  updateReceiverCurrency(val: string) {
    this.countryList.forEach(c => {
      if (c.currencyCode.toLowerCase() == val.toLowerCase()) {
        this.receiveCurrency = c;
        this.exchange.toCountryId = this.receiveCurrency['countryId'];
        this.exchange.toId = this.receiveCurrency['currencyCode'];
      }
    })
  }

  getExchangeRate() {
    this.formatDigits();
    this.localStorage.setItem('ex-calc', JSON.stringify(this.exchange));
    var exRateCalcUrl = "/singx/secure/CommonRestServiceImpl/getExchangeRates";
    if (this.country && this.country == "hk")
      exRateCalcUrl = environment.hkBase + exRateCalcUrl;
      // SG / HK / AU
      const data = {
        'fromCurrency': this.exchange.fromId,
        'toCurrency': this.exchange.toId,
        'amount': this.exchange.label == 'First' ? this.exchange.amount.replace(/[^0-9-.]/g, '') : this.exchange.receiveAmt.replace(/[^0-9-.]/g, ''),
        'type': this.exchange.label == 'First' ? 'Send' : 'Receive',
        'swift': false,
        'cashPickup': false,
        'wallet': false,
        'business': false
      }
      this.http.post(environment.apiBase + "/central/landing/fx/" + this.country.toUpperCase() + "/exchange", data, { headers: { 'Content-Type': 'application/json' } }).subscribe(resp => {
        this.exchange.amount = resp['sendAmount'];
        this.exchange.receiveAmt = resp['receiveAmount'];
        this.exchange.singxFee = resp['singxFee'];
        this.exchange.exchangeRate = resp['exchangeRate'];
        this.formatDigits();
      }, err => {
        alert('Failed to fetch exchange rate');
      })
    
  }

  private formatDigits() {
    //this.exchange.amount = +this.exchange.amount.toString().replace(/[^0-9-.]/g, '');
    //this.exchange.amount = (+this.exchange.amount).toFixed(2);
    if (!this.exchange.amount || this.exchange.amount == "")
      this.exchange.amount = "0";
    this.exchange.amount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2
    }).format(+(this.exchange.amount + "").replace(/[^0-9-.]/g, ''));

    //this.exchange.receiveAmt = +this.exchange.receiveAmt.toString().replace(/[^0-9-.]/g, '');
    //this.exchange.receiveAmt = (+this.exchange.receiveAmt).toFixed(2);
    if (!this.exchange.receiveAmt || this.exchange.receiveAmt == "")
      this.exchange.receiveAmt = "0";
    this.exchange.receiveAmt = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2
    }).format(+(this.exchange.receiveAmt + "").replace(/[^0-9-.]/g, ''));

    if (!this.exchange.singxFee || this.exchange.singxFee == "")
      this.exchange.singxFee = "0";
    this.exchange.singxFee = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2
    }).format(+(this.exchange.singxFee + "").replace(/[^0-9-.]/g, ''));
  }

  sendAmountChange($e) {
    this.sendAmountChanged.next($e);
  }

  receiveAmountChange($e) {
    this.receiveAmountChanged.next($e);
  }

  changeSendCurrency(sc) {
    this.sendCurrency = sc;
    this.exchange.fromCountryId = this.sendCurrency.countryId;
    this.exchange.fromId = this.sendCurrency.currencyCode;
    this.changeSendPopoverVisiblity(false);
    this.getExchangeRate();
  }

  changeReceiveCurrency(sc) {
    this.receiveCurrency = sc;
    this.exchange.toCountryId = this.receiveCurrency.countryId;
    this.exchange.toId = this.receiveCurrency.currencyCode;
    this.changeReceivePopoverVisiblity(false);
    this.getExchangeRate();
  }

  changeSendPopoverVisiblity($e) {
    this.exCalcSendPopoverVisible = $e;
  }

  changeReceivePopoverVisiblity($e) {
    this.exCalcReceivePopoverVisible = $e;
  }

}